module.exports = __webpack_public_path__ + "static/fc80d707d0b78c23873b0406111b217f2db0d32f0d55c3e3ce37848e2acb8ca3-7e3e4fbcc38e0ee6ddf0adec4db4418b.jpeg";